import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, NgModel } from '@angular/forms';

@Directive({
  selector: '[equelValueValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EquelValueValidatorDirective, multi: true }]
})
export class EquelValueValidatorDirective implements Validator {
  @Input('equelValueValidator') secondModel: NgModel;
  @Input('caseSensitive') caseSensitive: boolean = false;

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any; } {
    let secondControl: AbstractControl = this.secondModel.control;
    let valid = false;
    if ( control.value != null &&  secondControl.value != null) {
      if (this.caseSensitive) {
        valid = control.value === secondControl.value;
      }
      else {
        valid = control.value.toLocaleLowerCase() === secondControl.value.toLocaleLowerCase();
      }
    }
    let result = valid ? null : { 'equelValue': { 'first': control.value, 'second': secondControl.value } };

    //Update the attached control errors
    if (valid && secondControl.errors) {
      delete secondControl.errors['equelValue'];
      if (!Object.keys(secondControl.errors).length) secondControl.setErrors(null);
    }
    else {
      if (secondControl.errors)
        secondControl.errors['equelValue'] = result.equelValue;
      else
        secondControl.setErrors(result);
    }

    return result;
  }

}
